import React, { PureComponent } from 'react';
import { Row, Col, Input, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import Checkbox from '../field/checkbox';
import { without, range } from 'underscore';

export const AVAILABILITY_TYPES = [
  {
    label: 'All',
    value: ''
  },
  'Annual',
  'Seasonal',
  'Off-Season',
  'Weekly',
  'Monthly'
];

export const AVAILABILITY_TYPE_RENTAL = [
  {
    label: 'All',
    value: ''
  },
  'Weekly',
  'Monthly'
];

function RenderCheckbox(props) {
  const { input, meta, ...additionalProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);

  return (
    <Checkbox
      {...additionalProps}
      type="checkbox"
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.length > 1 && newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderRadio(props) {
  const { input, meta, ...additionalProps } = props;
  const checked =
    input.value === props.value || (input.value === undefined && props.value === '');

  return (
    <Checkbox
      {...additionalProps}
      type="radio"
      checked={checked}
      onChange={e => {
        const { checked, value } = e.target;

        var newValue = checked ? value : '';

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderOption(props) {
  const { label, input, meta, ...additionalProps } = props;

  return <option {...additionalProps}>{label}</option>;
}

class AvailabilityFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const {
      className,
      numCols,
      numColsSm,
      numInnerCols,
      numInnerColsSm,
      type,
      renderType,
      options,
      ...props
    } = this.props;
    const colSize = Math.ceil(12 / numCols);
    const colSizeSm = Math.ceil(12 / numColsSm);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const colInnerSizeSm = Math.ceil(12 / numInnerColsSm);
    const numPerCol = Math.ceil(options.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;
    switch (renderType) {
      case 'checkbox':
      default:
        return (
          <div className={`${BS.justifyContentSpaceBetween} ${BS.dFlex} ${BS.flexWrap}`}>
            {options.map(function (checkbox, i) {
              return (
                <RenderCheckbox
                  {...props}
                  key={i}
                  value={checkbox.value !== undefined ? checkbox.value : checkbox}
                  label={checkbox.label || checkbox}
                />
              );
            })}
          </div>
        );
      case 'radio':
        return (
          <Row className={className}>
            {range(numCols).map(col => {
              return (
                <Col key={col} sm={colSizeSm} md={colSize}>
                  <FormGroup>
                    <Row>
                      {range(numInnerCols).map(innerCol => {
                        return (
                          <Col key={innerCol} sm={colInnerSizeSm} md={colInnerSize}>
                            {range(numPerInnerCol).map(() => {
                              const checkbox = options[i];
                              i++;
                              return checkbox ? (
                                <RenderRadio
                                  {...props}
                                  key={i}
                                  className={labelClassName}
                                  value={
                                    checkbox.value !== undefined
                                      ? checkbox.value
                                      : checkbox
                                  }
                                  label={checkbox.label || checkbox}
                                />
                              ) : null;
                            })}
                          </Col>
                        );
                      })}
                    </Row>
                  </FormGroup>
                </Col>
              );
            })}
          </Row>
        );
      case 'select':
        return (
          <Input type="select" name={props.input.name} onChange={props.input.onChange}>
            {options.map(function (checkbox, i) {
              return (
                <RenderOption
                  {...props}
                  key={i}
                  value={checkbox.value !== undefined ? checkbox.value : checkbox}
                  label={checkbox.label || checkbox}
                />
              );
            })}
          </Input>
        );
    }
  }
}

AvailabilityFilter.defaultProps = {
  numCols: 2,
  numInnerCols: 1,
  numColsSm: 2,
  numInnerColsSm: 1,
  type: 'input',
  renderType: 'checkbox',
  options: AVAILABILITY_TYPES
};

export default AvailabilityFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/availability-filter.js